export default __webpack_public_path__ + "3ece448121571a3c3588fb7a7846669c.woff2";